/* eslint-disable import/no-unresolved */
import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import Button from '@components/Button/next';

import 'swiper/css';
import 'swiper/css/navigation';

export const DesktopStyledListingItem = styled.div<{
  isPeriodHotel: boolean;
  initialItem?: boolean;
}>`
  width: 100%;
  border-radius: 8px;
  outline: solid 1px ${({ theme }) => theme.palette.NL30};
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 8px;
  position: relative;
  ${({ isPeriodHotel }) => isPeriodHotel && 'border-bottom: 4px solid #F1332B'};
  ${({ isPeriodHotel }) =>
    isPeriodHotel && 'box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15)'};
`;

export const DesktopStyledListingItemWrapper = styled.div<{
  initialItem?: boolean;
}>`
  width: 100%;
  background-color: transparent;
  margin-bottom: 10px;
  ${({ initialItem }) => !initialItem && 'margin-top: 10px'};
`;

export const DesktopStyledListingItemBody = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 230px 1fr;
`;
export const DistanceWrapper = styled.div``;
export const DesktopStyledListingImageWrapper = styled.div`
  grid-column: 1/2;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
`;

export const MoileStyledListingItem = styled.div<{
  isPeriodHotel: boolean;
  initialItem?: boolean;
}>`
  width: 100%;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.NL30};
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 8px;
  position: relative;
  ${({ isPeriodHotel }) => isPeriodHotel && 'border-bottom: 4px solid #F1332B'};
  ${({ isPeriodHotel }) =>
    isPeriodHotel && 'box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15)'};
`;

export const MoileStyledListingItemWrapper = styled.div<{
  initialItem?: boolean;
}>`
  width: 100%;
  background-color: transparent;
  margin-bottom: 6px;
  ${({ initialItem }) => !initialItem && 'margin-top: 6px'};
`;

export const MobileStyledListingImageWrapper = styled.div`
  width: 100%;
  height: 230px;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
`;

export const DesktopListingItemBody = styled.div`
  width: calc(100% - 8px);
  height: 100%;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
`;

export const DesktopListingItemLocationContainer = styled.div`
  display: flex;
  gap: 12px;
  height: auto;
  justify-content: space-between;
`;
export const LocationTitle = styled.div``;
export const LocationRatings = styled.div`
  display: flex;
  gap: 16px;
`;
export const DesktopNameWrapper = styled.div`
  max-width: 100%;
  height: auto;
  max-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ShareWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: start;
`;

export const ShareWrapperMobile = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ListItemStarContainer = styled.div`
  display: flex;
`;

export const DesktopNameContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const MobileLocationContainer = styled.div`
  display: block;
  margin-top: 4px;
  height: auto;
`;
export const MobileBoardTypeContainer = styled.div`
  display: flex;
  margin-top: 4px;
  height: auto;
  justify-content: space-between;
`;

export const MobileNameContainer = styled.div`
  display: flex;
  line-height: normal;
  justify-content: space-between;
`;

export const MobileNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 55px);
`;

export const PaymentTypesBadgeWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`;
export const BankPostContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 5px;
`;
export const MobilePriceAndBadgeWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 8px;
  justify-content: space-between;
`;

export const PaymentTypesMobileBadgeWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  justify-content: flex-start;
  max-width: 204px;
`;

export const MobileHotelNameTextWrapper = styled.div`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: ${({ theme }) => theme.palette.NL800};
`;

export const ListingCardBodyWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  height: calc(100% - 74px);
`;

export const DesktopPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: flex-end;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;
  margin-top: 8px;
`;

export const DesktopDateSelectionWarningMessage = styled.div`
  text-align: center;
  max-height: 18px;
`;

export const DesktopDateSelectionButton = styled(Button)`
  width: 105px;
  height: 40px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.BR500};
  color: ${({ theme }) => theme.palette.BR500};
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 11px 24px;
  font-size: 14px;
  font-weight: 700;
  &:hover {
    background: ${({ theme }) => theme.palette.BR500};
    color: ${({ theme }) => theme.palette.NL0};
    box-shadow: 0 10px 30px 0 rgba(255, 65, 57, 0.5);
  }
`;

export const ShowHotelButtonWithDateSelection = styled.div`
  display: flex;
  height: 20px;
  text-decoration: underline;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: auto;
  }
`;

export const MobileDateSelectionContainer = styled.div`
  display: flex;
  height: 68px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  width: 100%;
  margin-top: 8px;
`;

export const MobileDateSelectionWarningMessage = styled.div`
  text-align: right;
  max-height: 18px;
`;

export const MobileDateSelectionButton = styled(Button)`
  width: 225px;
  height: 40px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.BR500};
  color: ${({ theme }) => theme.palette.BR500};
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 11px 24px;
  font-size: 14px;
  font-weight: 700;
`;

export const MobileDateSelectionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const DesktopDiscountAndNightCountWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
`;
export const DesktopperiodTypeWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.NL30};
  border-radius: 8px;
  padding: 4px;
  text-align: -webkit-right;
`;
export const DesktopSelectHotelButton = styled(Button)<{
  periodType?: boolean;
}>`
  width: ${({ periodType }) => (periodType ? '136px' : ' 103px')};
  height: 42px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.BR500};
  color: ${({ periodType, theme }) =>
    periodType ? theme.palette.white : theme.palette.BR500};
  background-color: ${({ periodType, theme }) =>
    periodType ? theme.palette.BR500 : theme.palette.NL0};
  padding: 11px 24px;
  font-size: 14px;
  font-weight: 700;

  &:hover {
    background: ${({ theme }) => theme.palette.BR500};
    color: ${({ theme }) => theme.palette.NL0};
    box-shadow: 0 10px 30px 0 rgba(255, 65, 57, 0.5);
  }
`;

export const MobileDiscountAndNightCountWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
`;

export const MobilePricingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const NightDiscountWrapperWithDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const NightDiscountWrapperWithoutDetails = styled.div`
  display: flex;
  gap: 8px;
`;

export const MobileSelectHotelButton = styled(Button)<{ periodType?: boolean }>`
  width: 100%;
  height: 42px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.BR500};
  color: ${({ theme, periodType }) =>
    periodType ? theme.palette.white : theme.palette.BR500};
  background-color: ${({ theme, periodType }) =>
    periodType ? theme.palette.BR500 : theme.palette.NL0};
  padding: 11px 24px;
  font-size: 14px;
  font-weight: 700;
  margin-top: 8px;
`;

export const DesktopBottomContainer = styled.div`
  display: flex;
  padding-top: 6px;
  align-items: center;
  align-self: stretch;
  width: 100%;
  border-top: solid 1px ${({ theme }) => theme.palette.NL30};
  height: 56px;
  margin-top: 6px;
`;

export const MobileBadgeContainer = styled.div`
  margin-top: 6px;
  border-top: solid 1px ${({ theme }) => theme.palette.NL30};
  display: flex;
  padding-top: 4px;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
  height: 36px;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  .swiper-slide {
    height: 32px;
    width: auto;
    box-sizing: border-box;
  }
`;

export const DesktopBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const DesktopPromotionsFeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 0 0;
  justify-content: flex-end;
`;

export const PeriodTypeWrapper = styled.div`
  position: absolute;
  top: 18px;
  display: flex;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  height: 26px;
  border-radius: 0px 4px 4px 0px;
  background-color: ${({ theme }) => theme.palette.BR400};
  z-index: 100;
  left: 0px;
`;

export const EventsBadgeWrapper = styled.div`
  display: flex;
  padding: 4px;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  border-radius: 8px 8px 0px 0px;
  background-color: ${({ theme }) => theme.palette.O500};
  height: 26px;
`;

export const EventsRowDesktop = styled.div`
  display: flex;
  padding-right: 10px;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;
`;
export const DistanceDetailWrapper = styled.div`
  margin-top: 3px;
  display: flex;
  align-items: center;
  gap: 3px;
  margin-left: 12px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 5px;
  }
`;
